import axios from "../index.js"

var menu = {
	// 获取全部模块为菜单用
	getMenu:function(data,success,failure){
		return axios.get(`${axios.apiRoot}/dashboard/getmodulenames`,data,success,failure);
	},
}
export default menu


// WEBPACK FOOTER //
// ./src/api/url/menu.js